function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { memo, useCallback, useMemo } from 'react';
import renderIf from '@signal/utils/renderIf';
import DesktopHeader from '../DesktopHeader';
import MainNavUserMenu from '../MainNavUserMenu';
import MultiAppMenu from '../MultiAppMenu';
import PureCarsMeridian from './PureCarsMeridianLogo';
import ServiceMenuNav from './ServiceMenuNav';

function getMultiAppMenu(props) {
  return function () {
    return /*#__PURE__*/React.createElement(MultiAppMenu, props);
  };
}

function getMainNavUserMenu(props) {
  return function () {
    return /*#__PURE__*/React.createElement(MainNavUserMenu, props);
  };
} // this is the common app header.


export function CommonHeader(_ref) {
  var children = _ref.children,
      extraMenuItems = _ref.extraMenuItems,
      hideMultiAppMenu = _ref.hideMultiAppMenu,
      location = _ref.location,
      onLogout = _ref.onLogout,
      onAccountChange = _ref.onAccountChange,
      onNavigate = _ref.onNavigate,
      showFontSlider = _ref.showFontSlider,
      UserMenuNavLinks = _ref.UserMenuNavLinks,
      headerProps = _objectWithoutProperties(_ref, ["children", "extraMenuItems", "hideMultiAppMenu", "location", "onLogout", "onAccountChange", "onNavigate", "showFontSlider", "UserMenuNavLinks"]);
  /**
   * This menu click handler opens full urls in a new tab, and
   * it opens app routes with the app router
   * @param {String} link the link to open
   */


  var handleMenuClick = useCallback(function (link) {
    return onNavigate(link);
  }, [onNavigate]);
  var MultiAppNavMenu = useMemo(function () {
    return getMultiAppMenu({
      extraMenuItems: extraMenuItems,
      onMenuItemClick: handleMenuClick
    });
  }, [extraMenuItems, handleMenuClick]);
  var RightHandMenu = useMemo(function () {
    return getMainNavUserMenu({
      onAccountChange: onAccountChange,
      onLogout: onLogout,
      showFontSlider: showFontSlider,
      UserMenuNavLinks: UserMenuNavLinks
    });
  }, [onAccountChange, onLogout, showFontSlider, UserMenuNavLinks]);
  return /*#__PURE__*/React.createElement(DesktopHeader, Object.assign({}, headerProps, {
    fullWidth: true,
    icon: PureCarsMeridian,
    MultiAppNavMenu: hideMultiAppMenu ? undefined : MultiAppNavMenu,
    RightHandMenu: RightHandMenu
  }), renderIf(children, function () {
    return children;
  }, function () {
    return /*#__PURE__*/React.createElement(ServiceMenuNav, {
      location: location,
      onNavigate: onNavigate
    });
  }));
}
export default /*#__PURE__*/memo(CommonHeader);